import { apiKey as llmApiKey } from '@rocketlane/rocket-llm';
import { CONVERSATION_SERVICE_URL } from 'config/environment';
import { ApiKey } from './api-key';
/** The local Conversation Service is reached through rocket-api's API-key proxy. */ export const usesRocketApiConversationProxy = (serviceUrl = CONVERSATION_SERVICE_URL)=>{
    try {
        const { hostname, port } = new URL(serviceUrl);
        return (hostname === 'localhost' || hostname === '127.0.0.1') && port === '8080';
    } catch (unused) {
        return false;
    }
};
/**
 * The SDK prefers its global API key over the per-response stream token. Keep
 * that key only for local streams routed through rocket-api; direct
 * Conversation Service streams must use the Bearer token returned by chat POST.
 */ export const syncRocketLlmApiKey = (serviceUrl = CONVERSATION_SERVICE_URL)=>{
    const useApiKey = usesRocketApiConversationProxy(serviceUrl);
    return ApiKey.tokens().subscribe((value)=>{
        if (useApiKey && value) {
            llmApiKey.set(value);
        } else {
            llmApiKey.clear();
        }
    });
};
